import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../../i18n/hooks';
import Button from '../../ui/components/Button';
import './PromoBanner.css';

const DISMISS_KEY = 'promoBanner_dismissed';

const PromoBanner = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(
    () => sessionStorage.getItem(DISMISS_KEY) === 'true'
  );

  const handleDismiss = () => {
    setDismissed(true);
    sessionStorage.setItem(DISMISS_KEY, 'true');
  };

  if (dismissed) return null;

  return (
    <div className="promo-banner" role="banner">
      <div className="promo-banner__content">
        <div className="promo-banner__body">
          <p className="promo-banner__title">{t('promoBanner.title')}</p>
          <p className="promo-banner__text">
            {t('promoBanner.text')}
          </p>
          <p className="promo-banner__disclaimer">{t('promoBanner.disclaimer')}</p>
        </div>
        <div className="promo-banner__actions">
          <Button
            variant="primary"
            size="small"
            onClick={() => navigate('/subscription')}
          >
            {t('promoBanner.cta')}
          </Button>
          <button
            className="promo-banner__dismiss"
            onClick={handleDismiss}
            aria-label={t('promoBanner.dismiss')}
            type="button"
          >
            ✕
          </button>
        </div>
      </div>
    </div>
  );
};

export default PromoBanner;
